
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bootcamp/[subtopic]/[key]",
      function () {
        return require("private-next-pages/bootcamp/[subtopic]/[key]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bootcamp/[subtopic]/[key]"])
      });
    }
  